var _path, _g, _g2, _g3, _g4, _g5, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 37,
    viewBox: "0 0 61 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.34 0.647705H4.89001C2.48758 0.647705 0.540039 2.59524 0.540039 4.99768V32.1777C0.540039 34.5801 2.48758 36.5277 4.89001 36.5277H56.34C58.7424 36.5277 60.6899 34.5801 60.6899 32.1777V4.99768C60.6899 2.59524 58.7424 0.647705 56.34 0.647705Z",
    fill: "#2C2B26"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.4302 6.00769H40.6001V8.31769H57.4302V6.00769Z",
    fill: "#80C5BE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6699 29.8677H4.43982C4.01456 29.8677 3.66992 30.2124 3.66992 30.6377C3.66992 31.063 4.01456 31.4077 4.43982 31.4077H15.6699C16.0952 31.4077 16.4398 31.063 16.4398 30.6377C16.4398 30.2124 16.0952 29.8677 15.6699 29.8677Z",
    fill: "#80C5BE"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4902 29.8677H19.2603C18.835 29.8677 18.4902 30.2124 18.4902 30.6377C18.4902 31.063 18.835 31.4077 19.2603 31.4077H30.4902C30.9155 31.4077 31.2603 31.063 31.2603 30.6377C31.2603 30.2124 30.9155 29.8677 30.4902 29.8677Z",
    fill: "#80C5BE"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.6499 29.8677H33.4199C32.9947 29.8677 32.6499 30.2124 32.6499 30.6377C32.6499 31.063 32.9947 31.4077 33.4199 31.4077H44.6499C45.0752 31.4077 45.4199 31.063 45.4199 30.6377C45.4199 30.2124 45.0752 29.8677 44.6499 29.8677Z",
    fill: "#80C5BE"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.6899 11.3376H0.540039V17.0276H60.6899V11.3376Z",
    fill: "#80C5BE"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5698 31.6776C52.9598 31.6776 51.6499 30.3676 51.6499 28.7576C51.6499 27.1476 52.9598 25.8376 54.5698 25.8376C56.1798 25.8376 57.4899 27.1476 57.4899 28.7576C57.4899 30.3676 56.1798 31.6776 54.5698 31.6776ZM54.5698 26.3776C53.2598 26.3776 52.1898 27.4476 52.1898 28.7576C52.1898 30.0676 53.2598 31.1376 54.5698 31.1376C55.8798 31.1376 56.9498 30.0676 56.9498 28.7576C56.9498 27.4476 55.8798 26.3776 54.5698 26.3776Z",
    fill: "#80C5BE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6603 31.6776C50.0503 31.6776 48.7402 30.3676 48.7402 28.7576C48.7402 27.1476 50.0503 25.8376 51.6603 25.8376C53.2703 25.8376 54.5802 27.1476 54.5802 28.7576C54.5802 30.3676 53.2703 31.6776 51.6603 31.6776ZM51.6603 26.3776C50.3503 26.3776 49.2803 27.4476 49.2803 28.7576C49.2803 30.0676 50.3503 31.1376 51.6603 31.1376C52.9703 31.1376 54.0403 30.0676 54.0403 28.7576C54.0403 27.4476 52.9703 26.3776 51.6603 26.3776Z",
    fill: "#80C5BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarta);
export default __webpack_public_path__ + "static/media/carta.c09a533e4ee32fe8cf525f0487f2c380.svg";
export { ForwardRef as ReactComponent };